<template>
  <div id="user-rights">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <el-form
          ref="formselect"
          :model="formselect"
          label-width="100px"
          class="queryform_div"
        >
          <el-row :gutter="24">
            <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('desc.userName')">
                <el-input
                  v-model="formselect.userName"
                  size="small"
                    style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="12" :xs="24">
              <el-form-item :label="$t('desc.airCompressorSN')">
                <el-input
                  v-model="formselect.dsn"
                  size="small"
                    style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="24" :xs="24" style="margin-top: 10px">
              <el-button
                @click="getUserList('search')"
                type="primary"
                size="small"
                >{{ $t("button.query") }}</el-button
              >
              <el-button @click="reset" size="small">{{
                $t("button.reset")
              }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <template>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="openDialog(true)"
            style="margin-bottom: 10px"
            v-if="hasCreateAuth"
            >{{ $t("desc.createUserDeviceRel") }}
          </el-button>
          <el-button
            type="default"
            icon="el-icon-upload2"
            @click="showImportDialog(true)"
            style="margin-bottom: 10px"
            v-show="hasImportAuth"
            >{{ $t("button.bulkImport") }}</el-button
          >
          <el-button
            type="default"
            icon="el-icon-download"
            style="margin-bottom: 10px"
            @click="exportUserList()"
            :loading="loading"
            v-if="hasExportAuth"
            >{{ $t("button.exportAll") }}</el-button
          >
          <a
            v-if="activeLang == 'en'"
            class="el-button el-button--default el-button--small"
            style="margin-bottom: 10px; text-decoration: none; float: right"
            href="/file/Excel Import Template - Man Equipment Comparison.xlsx"
            download="Excel Import Template - Man Equipment Comparison.xlsx"
            >{{ $t("desc.exportManEquipmentRelTemplate") }}</a
          >
          <a
            v-else
            class="el-button el-button--default el-button--small"
            style="margin-bottom: 10px; text-decoration: none; float: right"
            href="/file/EXCEL导入模板-人机对照关系.xlsx"
            download="EXCEL导入模板-人机对照关系.xlsx"
            >{{ $t("desc.exportManEquipmentRelTemplate") }}</a
          >
          <div class="tableDiv">
          <el-table :data="userInfoList" stripe style="width: 100%" :empty-text="$t('desc.noData')">
            <el-table-column
              type="index"
              :label="$t('title.serialNumber')"
              width="60"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              prop="email"
              :label="$t('title.emailAddress')"
              min-width="20%"
            >
            </el-table-column>
            <el-table-column
              prop="userName"
              :label="$t('title.account')"
              min-width="20%"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('desc.userName')"
              min-width="12%"
            >
            </el-table-column>
            <el-table-column
              prop="mobilePhone"
              :label="$t('title.mobilePhone')"
              min-width="12%"
            >
            </el-table-column>
            <el-table-column
              prop="dsn"
              :label="$t('desc.airCompressorSN')"
              min-width="10%"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.operate')"
              width="80"
              fixed="right"
            >
              <template slot-scope="scope">
                <template>
                  <el-popconfirm
                    placement="top"
                    :confirmButtonText="$t('button.delete')"
                    :cancelButtonText="$t('button.cancel')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('title.confirmDelete')"
                    v-if="hasDeleteAuth"
                    @confirm="deleteEleById(scope.row.id)"
                  >
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      :title="$t('button.delete')"
                      circle
                      size="mini"
                      slot="reference"
                      :disabled="scope.row.isIotNew == false"
                    ></el-button>
                  </el-popconfirm>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="pagination.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="prev, pager, next,sizes"
            :total="pagination.totalPage"
            style="text-align: center; margin-top: 10px"
          >
          </el-pagination>
          </div>
        </template>
      </el-main>
    </el-scrollbar>
    <el-dialog
      :title="title"
      v-if="dialogAddUser"
      :visible.sync="dialogAddUser"
      width="60%"
      style="height: 350px; margin-top: 15%;"
      top="5vh"
    >
      <el-form
        ref="userformref"
        :model="userform"
        label-width="120px" 
      >
        <el-form-item
          :label="$t('title.account')"
          prop="userName"
          :rules="[
            {
              required: true,
              message: $t('tips.enterAccount'),
              trigger: 'blur',
            },
           ]"
        >
          <el-select
            v-model="userform.userName"
            filterable
            reserve-keyword
            :placeholder="$t('desc.select')"
            style="width: 80%"
          >
            <el-option
              v-for="(item, index) in sfaUserList"
              :key="item"
              :value="item"
              :label="item"
            >
              <span style="float: left; margin-right: 5px">{{
                item
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('desc.airCompressorSN')"
          prop="dsn"
          :rules="[
            {
              required: true,
              message: $t('tips.enterUserName'),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="userform.dsn"
            filterable
            remote
            reserve-keyword
            :placeholder="$t('desc.select')"
            :remote-method="remoteDsnMethod"
            :loading="loading1"
            style="width: 80%"
            v-el-select-loadmore="loadMore(selectPageSize)"
          >
            <el-option
              v-for="(item, index) in dsnOptionShow.slice(0, selectPageSize)"
              :key="item.id"
              :value="item.label"
              :label="item.label"
            >
              <span style="float: left; margin-right: 5px">{{
                item.label
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item style="margin-left: 120px">
              <el-button type="success" @click="onSubmit()">{{
                $t("button.confirm")
              }}</el-button>
              <el-button @click="dialogAddUser = false">{{
                $t("button.cancel")
              }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <import-dialog
      ref="importRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('button.bulkImportCustomer'))"
      :dialogImportClient="dialogImportClient"
      :form="form"
      :loading="importLoading"
      @onSubBtn="uploadFile"
      @dialogVisibleEvent="showImportDialog"
    ></import-dialog>
  </div>
</template>

<script>
import {
  authOperationCheck,
  getUserDeviceList,
  addUserDeviceRel,
  deleteUserDeviceRel,
  GetAllDevice,
  getSfaUserList,
  exportExcelNew,
  importUserDeviceRel
} from "../../api/api";
import agencyImportComponent from "../../components/content/maintabber/ExportExcelFile";
import { mapState, mapGetters } from "vuex";

export default {
  name: "UserDeviceRel",
  components: {
    "import-dialog": agencyImportComponent,
  },
  data() {
    return {
      formselect:{
        userName:"",
        dsn:""
      },
      userInfoList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      dialogAddUser: false,
      userform: {

      },
      selectPageSize: 30,
      loading: false,
      loading1: false,
      hasCreateAuth: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasExportAuth: false,
      hasImportAuth: false,
      title:"",
      dsnOptionShow: [],
      dsnOption: [],
      sfaUserList: [],
      //导入
      dialogTitle: "",
      dialogImportClient: false,
      form: {},
      importLoading: false,
    };
  },
  created: function () {
    this.authOperation("UserDeviceRel");
  },
  async mounted() {
    this.getUserList();
    this.getAllDevice();
    this.getSfaUserList();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasExportAuth = res.hasExportAuth;
      that.hasImportAuth = res.hasImportAuth;
    },
    reset() {
      this.formselect.userName = "";
      this.formselect.dsn = "";
      this.getUserList("search");
    },
    async getUserList(type = "normal"){
      if (type == "search") {
        this.pagination.current = 1;
      }
      let postdata = {
        ...this.formselect,
        skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
        maxResultCount: this.pagination.pageSize
      }
      let res = await getUserDeviceList(postdata);
      this.userInfoList = res.result.items;
      this.pagination.totalPage = res.result.totalCount;
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getUserList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getUserList();
    },
    async exportUserList(){
      let that = this;
      that.loading = true;

      var fileName = that.$t("desc.UserDeviceRelList")+".csv";
      let postdata = {
        ...this.formselect,
        skipCount: 0,
        maxResultCount: 1000000
      }
      let res = await getUserDeviceList(postdata);
      let data = res.result.items;
      //导入数据里有null会导致文件损坏
      const dataSource = data.map((item) => {
        Object.keys(item).forEach((key) => {
          // 后端传null node写入会有问题
          if (item[key] === null) {
            item[key] = "";
          }
          if (Array.isArray(item[key])) {
            item[key] = item[key].join(",");
          }
        });
        return item;
      });
      let header = [
        that.$t('title.emailAddress'),
        that.$t('title.account'),
        that.$t('desc.userName'),
        that.$t('title.mobilePhone'),
        that.$t('desc.airCompressorSN'),
      ];
      let exportContent = new Array();
      dataSource.forEach((item) => {
        let rowData = new Object();
        rowData = {
          email: item.email,
          userName: item.userName,
          name: item.name,
          mobilePhone: item.mobilePhone,
          dsn: item.dsn,
        };
        exportContent.push(rowData);
      });
      exportExcelNew({ header }, fileName, exportContent);
      that.loading = false;
    },
    openDialog(visiable){
      this.dialogAddUser = visiable;
      this.title = this.$t("desc.createUserDeviceRel")
    },
    async getAllDevice(){
      let that = this;
      let res = await GetAllDevice();
      that.dsnOption = res.result.map((item) => {
        return {
          id: `${item.id}`,
          label: `${item.dsn}`,
        };
      });
      this.dsnOptionShow = JSON.parse(JSON.stringify(this.dsnOption));
    },
    async getSfaUserList(){
      let res = await getSfaUserList();
      this.sfaUserList = res.result;
    },
    loadMore(n) {
      return () => (this.selectPageSize += 5); // 每次滚动到底部可以新增条数  可自定义
    },
    remoteDsnMethod(query){
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          this.dsnOptionShow = this.dsnOption.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.dsnOptionShow = this.dsnOption;
      }
    },
    async onSubmit(){
      try {
        await addUserDeviceRel(this.userform);
        this.$message.success(this.$t("tips.updateSuccess"));
        this.dialogAddUser = false;
        this.getUserList();
      } catch (error) {
        this.$message.error(error.error.message);
      }
    },
    async deleteEleById(id){
      try {
        await deleteUserDeviceRel(id);
        this.$message.success(this.$t("tips.deleteSuccess"));
        this.getUserList();
      } catch (error) {
        this.$message.error(error.error.message);
      }
    },
    //导入
    showImportDialog(visible) {
      this.dialogImportClient = visible;
      this.form.datalist = [];
      if (this.$refs.importRef.$refs.airFormImport != undefined) {
        this.$refs.importRef.$refs.airFormImport.resetFields();
      }
    },
    uploadFile() {
      let that = this;
      this.importLoading = true;
      var datalist = that.form.datalist;
      var msgArr = [];
      var index = 2;
      var postData = [];
      datalist.map((v) => {
        let obj = {};
        if (that.activeLang == 'en'){
          obj.Dsn = v["Dsn"];
          obj.UserName = v["Email"];
        }else {
          obj.Dsn = v["空压机SN号"];
          obj.UserName = v["邮箱"];
        }
        
        var msg = "";
        
        if (obj.Dsn == undefined || obj.Dsn == "") {
          msg = that.$t("importError.dsnIsEmpty");
        }
        if (obj.UserName == undefined || obj.UserName == "") {
          msg += " " + that.$t("importError.emailIsEmpty");
        }
        else if (!this.sfaUserList.some(a=>a == obj.UserName)) {
          msg += that.$t("importError.noSuchEmail");
        }
        if (msg != "") {
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:") + msg);
        } else {
          postData.push(obj);
        }
        index++;
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        this.importLoading = false;
        return false;
      }
      importUserDeviceRel(postData, 2 * 60 * 1000)
        .then((res) => {
          that.dialogImportClient = false;
          this.importLoading = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.importSuccess"),
            type: "success",
          });
          that.getUserList();
        })
        .catch((err) => {
          this.importLoading = false;
          
          if (err.error.message.indexOf("系统中不存在客户：") > -1 && that.activeLang == 'en') {
            err.error.message = err.error.message.replace("系统中不存在客户：","These customers do not exist in the system: ")
          }
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    find(array, model) {
      var index = array.findIndex((item) => item.Dsn === model.Dsn);
      return index; // -1 说明array中不存在id为str的对象
    },
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
      navselected: (state) => state.adminleftnavnum,
    }),
  },
  directives: {
    "el-select-loadmore": (el, binding) => {
      const SELECTWRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const condition =
            this.scrollHeight - this.scrollTop - 10 <= this.clientHeight;
          if (condition) binding.value();
        });
      }
    },
  },
};
</script>

<style>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
